import { useTranslation } from "react-i18next";

import SignUpSteps from "../components/SignUpSteps/SignUpSteps";

import useUserStore from "@/features/auth/store/useUserStore.ts";
import Register from "@/features/auth/components/SignUpSteps/RegisterSteps/RegisterSteps.tsx";

const SignUp = () => {
  const { t } = useTranslation("auth");
  const { user } = useUserStore();

  return (
    <>
      <title>{`${t("signUp.signUp")} - Ximly`}</title>
      {user && <SignUpSteps />}
      {!user && <Register />}
    </>
  );
};

export default SignUp;
